export enum MailboxLoadErrorType {
  UNKNOWN = 'UNKNOWN',
  AUTH_ERROR = 'AUTH_ERROR',
  UNSUPPORTED_ACTION = 'UNSUPPORTED_ACTION',
}
